@if ({ groupData: (groupData$ | async), isLoadingGroupData: (isLoadingGroupData$ | async) }; as groupDataObservables) {
  <div
    class="fullPageContainer"
    >
    @if (!groupDataObservables.isLoadingGroupData && groupDataObservables.groupData) {
      <abc-grid
        #objectSelectionGrid
        [setupDefaultLayoutOnInitialization]="true"
        [autoFilterSelectedRows]="true"
        [keyExpr]="keyExpr"
        [selection]="{ mode: 'multiple', selectAllMode: 'allPages', showCheckBoxesMode: 'always' }"
        (onCellPrepared)="onCellPrepared($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        (onContentReady)="onContentReady($event)"
        (onPrepareDataSourceObject)="onPrepareDataSourceObject($event)"
      [dataSourceObject]="{
        dataSource: groupDataObservables.groupData.dataRows,
        gridColumns: groupDataObservables.groupData.gridColumns,
        storageKey: groupDataObservables.groupData.storageKey,
        storage: groupDataObservables.groupData.storage,
        getSelectedRowKeys: getPreselectedRowKeysFunc
      }"
        [rowAlternationEnabled]="true"
        id="objectSelectionGrid"
        >
      </abc-grid>
    } @else {
      <div class="fullPageContainer" fxFill fxLayout="row" fxLayoutAlign="center center">
        <dx-load-indicator ngClass="task-icon" ngClass.lt-sm="task-icon small"> </dx-load-indicator> Daten werden geladen...
      </div>
    }
  </div>
}
